import { render } from "./DenyAccess.vue?vue&type=template&id=e55d8182&scoped=true"
import script from "./DenyAccess.vue?vue&type=script&lang=ts"
export * from "./DenyAccess.vue?vue&type=script&lang=ts"

import "./DenyAccess.vue?vue&type=style&index=0&id=e55d8182&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e55d8182"

export default script